var map = {
	"./junk-1.webp": 17749,
	"./junk-2.webp": 5427,
	"./junk-3.webp": 19947,
	"./junk-4.webp": 2619,
	"./junk-5.webp": 58903,
	"./junk-6.webp": 21208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30846;